import { useEffect } from 'react';
import { App } from 'antd';
import { CheckCircle, X, WarningCircle, Info } from '@phosphor-icons/react';
import ReactDOM from 'react-dom/client';
import { NotificationType, AlertNotificationProps } from 'types/notification.types';

const getIcon = (type: NotificationType) => {
  const iconMap = {
    success: <CheckCircle color={'var(--sematicSuccessColor)'} weight='fill' size={20} />,
    error: <WarningCircle color={'var(--sematicErrorColor)'} weight='fill' size={20} />,
    warning: <WarningCircle color={'var(--sematicWarningColor)'} weight='fill' size={20} />,
    info: <Info color={'var(--sematicInfoColor)'} weight='fill' size={20} />,
  };
  return iconMap[type];
};

const getBorderColor = (type: NotificationType) => {
  const colorMap = {
    success: 'border-l-[var(--sematicSuccessColor)]',
    error: 'border-l-[var(--sematicErrorColor)]',
    warning: 'border-l-[var(--sematicWarningColor)]',
    info: 'border-l-[var(--sematicInfoColor)]',
  };
  return colorMap[type];
};

const NotificationProvider = ({
  type = 'success',
  title,
  message,
  duration = 4.5,
  onClose,
}: AlertNotificationProps) => {
  const { notification } = App.useApp();

  useEffect(() => {
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    notification.open({
      message: <span className='text-[16px] leading-[24px] font-bold text-[var(--textBlack)]'>{title}</span>,
      description: (
        <div className='mr-4'>
          <p className='text-[14px] leading-[20px] text-[var(--textBlack80)]'>{message}</p>
          <span className='block text-[12px] leading-[16px] text-[var(--textBlack56)] mt-2'>{time}</span>
        </div>
      ),
      icon: getIcon(type),
      className: `rounded-lg shadow-md bg-white w-[400px] h-[108]  border-l-4 ${getBorderColor(type)}`,
      placement: 'topRight',
      duration,
      closeIcon: <X color={'var(--textBlack56)'} weight='regular' size={24} />,
      style: {
        padding: 16,
        paddingLeft: 24,
        zIndex: 100,
      },
      onClose, // Thêm dòng này để callback được gọi khi notification đóng
    });
  }, [notification, type, title, message, duration, onClose]);

  return null;
};

export const showAlertNotification = (props: AlertNotificationProps) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);

  let isMounted = true;

  root.render(<App>{isMounted ? <NotificationProvider {...props} /> : null}</App>);
  const cleanupTime = (props.duration || 4.5) * 1000 + 1000;
  setTimeout(() => {
    if (isMounted) {
      isMounted = false;
      root.unmount();
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }
  }, cleanupTime);
};

export default showAlertNotification;
